import React, {useState} from 'react';
import {Box} from '@chakra-ui/react';
import {Redirect, Route, Switch, useRouteMatch} from 'react-router-dom';
import Header from '../../layout/Header';
import SideBar from '../../layout/SideBar';
import StudentHome from './StudentHome';
import StudentProfile from "./StudentProfile";
import StudentChangePassword from "./StudentChangePassword";
import StudentClass from "./StudentClass";
import StudentAssignments from "./StudentAssignments";
import StudentNotes from "./StudentNotes";
import StudentLessons from "./StudentLessons";
import StudentCourses from "./StudentCourses";

export default function Student() {
  let {path, url} = useRouteMatch();
  console.log(path, url);

  const [menuOpen, setMenuOpen] = useState<boolean>(true);
  const [menuClosed, setMenuClosed] = useState<boolean>(false);
  const [menuContent, setMenuContent] = useState<boolean>(true);

  // menu close
  function closeMenu(): void {
    setMenuOpen(false);
    setMenuClosed(true);
    setMenuContent(false);
  }

  // menu open
  function openMenu(): void {
    setMenuOpen(true);
    setMenuClosed(false);
    setMenuContent(true);
  }

  return (
    <Box h={"100%"}>
      <SideBar menuOpen={menuOpen} menuClosed={menuClosed} menuContent={menuContent} openMenu={openMenu}
               closeMenu={closeMenu}/>
      <Header menuOpen={menuOpen} menuClosed={menuClosed} menuContent={menuContent} openMenu={openMenu}
              closeMenu={closeMenu}/>
      <Box ml={{lg: "300px"}} pb={5} onClick={()=> closeMenu()}>
        <Switch>
          <Route exact path={path} component={StudentHome}/>
          <Route path={`${path}/classes`} component={StudentClass}/>
          <Route path={`${path}/assignments`} component={StudentAssignments}/>
          <Route path={`${path}/notes`} component={StudentNotes}/>
          <Route path={`${path}/lessons`} component={StudentLessons}/>
          <Route path={`${path}/profile`} component={StudentProfile}/>
          <Route path={`${path}/change-password`} component={StudentChangePassword}/>
          <Route path={`${path}/registered-courses`} component={StudentCourses} />
          <Route path="*">
            <Redirect to={path}/>
          </Route>
        </Switch>
      </Box>
    </Box>
  )
}
